import * as materials from "@lts/materials/legacy/legacy-sky";
export { materials };
export default materials;
